<div class="titleBox"> <h1 style="text-align: center">Customers</h1></div>
<div><hr></div>
<br>
<br>
<div style="margin-top: 20px; display: flex; justify-content: end;">
  <span><label>Hide Inactive Customers</label></span>
  <label class="switch">
    <input type="checkbox" [checked]="activeCustomerToggle" (click)='filterActiveCustomers()'>
    <span class="slider round"></span>
  </label>
</div>
<button mat-raised-button (click)="addCustomerDialog()"> Add New Customer</button>
      <ngx-table [configuration] = "configuration"  [data]="filterActiveCustomer$ | async" [columns]="columns" [loadingTemplate] = "loadingTemplate">
          <ng-template let-row>
            <td>
              <div>
                <button button mat-raised-button color="green" (click)="openDialog(row)">
                  <fa-icon [icon]="faedit"></fa-icon>
                </button>
              </div>

              <div>
                <button mat-button color="warn" title="Make Inactive" (click)="deleteCustomerDialog(row)">
                  <fa-icon [icon]="fadeactivate"></fa-icon>
                </button>
              </div>

              <div>
                <button mat-button color="#424242" (click)="openAdditionalWorkDialog(row)">
                  <fa-icon [icon]="faplussquare"></fa-icon>
                </button>
              </div>

            </td>


            <td [style]='row.inactivecustomer ? "background-color: #ffc4c4;" : "background-color:white;"'>
              <div>
                <span *ngIf="row.inactivecustomer"><p style="color:red; font-style: italic;"> Inactive</p></span>
                {{row.customer_name}}
              </div>
            </td>

            <td>
              <div>
                {{row.billing_notes}}
              </div>
            </td>

            <td>
              <div>
                {{row.office_street_address}} {{row.office_city}},{{row.office_state}},{{row.office_zip}}
              </div>
            </td>

            <td>
              <div>
                {{row.customer_note}}
              </div>
            </td>



          </ng-template>
        </ngx-table>






<ng-template #loadingTemplate>
  <td [attr.colspan]="columns.length">
    <div style= "width: 100%; text-align: center">
      <div style="display: inline-block; margin: auto; padding: 3px">
          <div class="lds-ripple"><div></div><div></div>Loading...</div>
      </div>
    </div>
  </td>
</ng-template>

